interface IconProps {
  fillColor: string
}

export const CancelledErrorIcon = ({ fillColor }: IconProps) => {
  return (
    <div className="illustration__icon-wrapper">
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32 61.7333C48.4213 61.7333 61.7333 48.4213 61.7333 32C61.7333 15.5787 48.4213 2.26667 32 2.26667C15.5787 2.26667 2.26667 15.5787 2.26667 32C2.26667 48.4213 15.5787 61.7333 32 61.7333ZM32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.7955 41.0498C40.3496 41.4891 39.632 41.4837 39.1927 41.0378L23.1927 24.7953C22.7535 24.3494 22.7589 23.6319 23.2048 23.1926C23.6507 22.7534 24.3683 22.7587 24.8075 23.2047L40.8075 39.4471C41.2468 39.893 41.2414 40.6106 40.7955 41.0498Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.0714 40.9165C22.6322 40.4706 22.6376 39.7531 23.0835 39.3138L39.3259 23.3138C39.7718 22.8746 40.4894 22.88 40.9286 23.3259C41.3679 23.7718 41.3625 24.4893 40.9166 24.9286L24.6741 40.9286C24.2282 41.3679 23.5107 41.3625 23.0714 40.9165Z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}
